import React from 'react';
import {Modal} from "react-bootstrap";
import {ArrowRight} from "react-bootstrap-icons";
import Description from "../Description";
import {routes} from "../../utils";

export default function FreeProductModal({ onClose }: { onClose: () => void }) {
    return (
        <Modal show size="sm" className="text-center" contentClassName="bg-neutral-200" onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>Basic Subscription</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Description className="mt-3">You automatically have the free subscription.</Description>
                <a href={routes.download} className="btn btn-action my-3">
                    Download Photo51&nbsp;
                    <ArrowRight size={20} />
                </a>
            </Modal.Body>
        </Modal>
    );
}
